import React from "react";
import styled from "styled-components";

const StyledPangPangWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const StyledPangPangCanvas = styled.canvas`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const StyledSiriWaveContainer = styled.div`
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    border-radius: 50%;
`;

const StyledSiriWave = styled.div`
    transform: translate(0, 0);
    opacity: 1;
`;

interface ISiriWave {
    ratio: number;
}

export default class SiriWave extends React.Component<ISiriWave> {

    componentDidMount(): void {
        // @ts-ignore
        if (window['drawPangPang']) {
            // @ts-ignore
            window['drawPangPang'](this.props.ratio)
        }
    }

    render() {
        return (
            <StyledPangPangWrapper data-ratio={this.props.ratio} className={"pangpang-wrapper"}>
                    <StyledPangPangCanvas className={"pangpang"}/>
                    <StyledSiriWaveContainer className={"siri-wave-wrapper"}>
                        <StyledSiriWave className={"siri-wave"}/>
                    </StyledSiriWaveContainer>
            </StyledPangPangWrapper>
        );
    }
}
